import { useDispatch } from 'react-redux'
import ValidateUserForm from 'src/components/Form/ValidateUserForm'
import Modal from 'src/components/Modal'
import Button from 'src/components/Button'
import Text from 'src/components/Text'
import { DarkRedHover, Red } from 'src/assets/colors'
import { actions } from 'src/features/state'
import { Formik, Form } from 'formik'
import FormField from 'src/components/Form/FormField'

import * as Yup from 'yup'
import ConfirmationModal from 'src/components/ConfirmationModal'
import stockApi from 'src/services/StockApi'
import { useState } from 'react'

interface Props {
  user: any
  handleModalChangePosition: any
  openModalChangePosition: any
  queueRow: any
  updateCurrentTab: any
}

export const ChangePositionModal = (
  {
    user,
    handleModalChangePosition,
    openModalChangePosition,
    queueRow,
    updateCurrentTab,
  }: Props,
) => {
  const dispatch = useDispatch()
  const [errorsChangePosition, setErrorsChangePosition] = useState<string>()
  const [
    openModalConfirmationChangePosition,
    setOpenModalConfirmationChangePosition,
  ] = useState(false)
  const handleModalConfirmationChangePosition = () => {
    setOpenModalConfirmationChangePosition((prevState) => !prevState)
  }
  const [position, setPosition] = useState<number>()

  const handleChangePosition = () => {
    setErrorsChangePosition(undefined)
    const data = {
      receivement_id: queueRow.receivement_id,
      new_queue_position: position,
    }
    stockApi
      .patch('/receivement/queue', data)
      .then(() => {
        setPosition(undefined)
        setErrorsChangePosition(undefined)
        handleModalChangePosition()
        handleModalConfirmationChangePosition()
        updateCurrentTab()
        dispatch(actions.setUserBadge(false))
      })
      .catch((err) => {
        if (err.response) {
          const errorData = err.response.data
          setErrorsChangePosition(errorData.message)
        } else {
          setErrorsChangePosition(
            'Não foi possível completar a requisição, verifique a conexão com a internet',
          )
        }
        handleModalConfirmationChangePosition()
      })
  }
  return (

    <Modal
      title='Alterar Posição'
      centered
      body={(
        <div style={{ padding: '15px' }}>
          {user ? (
            <>
              <Formik
                initialValues={{
                  position: undefined,
                }}
                validationSchema={Yup.object().shape({
                  position: Yup.number()
                    .required('form.required')
                    .test(
                      'validate-position',
                      'supplierQueue.error.position',
                      (value: any) => value > 0,
                    ),
                })}
                onSubmit={(values) => {
                  setPosition(values.position)
                  handleModalConfirmationChangePosition()
                }}
                validateOnChange={false}
                validateOnBlur={false}
              >
                {({ handleSubmit }) => (
                  <Form
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  >
                    <Button
                      text='MOVER PARA PRIMEIRO DA FILA'
                      style={{ borderRadius: '4px' }}
                      onClick={() => {
                        setPosition(1)
                        handleModalConfirmationChangePosition()
                      }}
                    />
                    <Text
                      plainText='ou'
                      style={{ textAlign: 'center', margin: '10px 0' }}
                    />
                    <FormField
                      name='position'
                      fieldType='number'
                      label='Inserir Posição:'
                      styleLabel={{ textAlign: 'center' }}
                      styleContainer={{
                        justifyContent: 'center',
                        margin: 0,
                      }}
                      onKeyPress={(event) => {
                        if (event.key === 'Enter') {
                          event.preventDefault()
                          handleSubmit()
                        }
                      }}
                    />
                    <Button
                      text='MOVER PARA POSIÇÃO'
                      style={{ margin: '10px 0 0 0', borderRadius: '4px' }}
                      onClick={handleSubmit}
                    />
                    {errorsChangePosition && (
                    <Text
                      plainText={errorsChangePosition}
                      style={{ color: Red }}
                    />
                    )}
                  </Form>
                )}
              </Formik>
              <ConfirmationModal
                yesButtonAction={handleChangePosition}
                noButtonAction={handleModalConfirmationChangePosition}
                bodyText={`Deseja confirmar a mudança na posição do recebimento de ${queueRow.position} para ${position} ?`}
                isShow={openModalConfirmationChangePosition}
                errorText=''
              />
            </>
          ) : (
            <>
              <div>
                <ValidateUserForm />
              </div>
              <div
                style={{
                  borderTop: '1px solid #C4C4C4',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  marginTop: '10px',
                  paddingTop: '10px',
                }}
              >
                <Button
                  text='cancel'
                  style={{ height: '34px' }}
                  color={Red}
                  hoverColor={DarkRedHover}
                  onClick={handleModalChangePosition}
                />
              </div>
            </>
          )}
        </div>
    )}
      closedButton
      closeButtonAction={() => {
        handleModalChangePosition()
        dispatch(actions.setUserBadge(false))
      }}
      show={openModalChangePosition}
    />
  )
}
